module.exports = __webpack_public_path__ + "weibo.5adb47ce.png";